namespace $ {
	$.$giper_baza_mine = $giper_baza_mine_idb
}
